import { InjectionToken } from '@angular/core';

export interface IRecaptchaConfig {
  siteKey: string;
}

export const RECAPTCHA_CONFIG: InjectionToken<IRecaptchaConfig> =
  new InjectionToken('IRecaptchaConfig');
